import '../style/Search.css';
const SearchBar = ({ searchQuery, setSearchQuery }) => {
    return (
        <div className="employeeSearchForm">
            <label htmlFor="header-search">
                <span className="visually-hidden">
                    Search employees
                </span>
            </label>
            <div>
                <input
                    value={searchQuery}
                    onInput={(e) => setSearchQuery(e.target.value)}
                    type="text"
                    id="header-search"
                    placeholder="Search employees"
                    name="s"
                    className="employeeSearch"
                />
            </div>
        </div>
    );
};

export default SearchBar;